import React from 'react';
import { Modal } from 'antd';

export const Popup = (props) => {
  const { onCancel, content, title, closable, visibility, width } = props;

  return (
    <Modal
      centered
      //maskClosable={false}
      closable={closable}
      wrapClassName={props.class}
      visible={visibility}
      okButtonProps={{ className: 'ag-gray-button' }}
      cancelButtonProps={{ className: 'ag-gray-button-outline' }}
      title={title && title}
      footer={null}
      width={width}
      onCancel={onCancel}
      destroyOnClose={true}
    >
      {content}
    </Modal>
  );
};
